<template>
    <div>
        <h1 class="is-size-5-mobile title">Nuestros productos</h1>

        <div class="tile is-ancestor">
            <div class="tile is-6 is-parent">
                <div class="tile is-child almacen" v-on:click="onCategorySelected(16)">
                    <h1>Almacen</h1>
                </div>
            </div>
            <div class="tile is-3 is-vertical is-parent">
                <div class="tile is-child hortalizas" v-on:click="onCategorySelected(15)">
                    <h1>Hortalizas</h1>
                </div>
                <div class="tile is-child granja" v-on:click="onCategorySelected(17)">
                    <h1>Granja</h1>
                </div>
            </div>
            <div class="tile is-3 is-parent is-vertical">
                <div class="tile is-child frutas" v-on:click="onCategorySelected(13)">
                    <h1>Frutas</h1>
                </div>
                <div class="tile is-child mermeladas" v-on:click="onCategorySelected(19)">
                    <h1>Mermeladas</h1>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'HomeProductCategories',
        data() {
            return {

            }
        },
        components: {

        },

        mounted() {

        },

        methods: {
            onCategorySelected(id) {
                this.$router.push({name: 'Products', params: {id: id}}).catch(err => {});
            }
        }
    }
</script>

<style lang="scss">
    .template-layout {
        > .header {
            background-image: url('./../../assets/img/homepage-2.jpg');
        }
    }
</style>

<style lang="scss" scoped>
    section.categories {
        .container {
            display: flex;
            flex-direction: column;
            flex-grow: 1;

            .tile {
                &.is-ancestor {
                    height: 600px;
                }

                @include mobile {
                    height: 200px;
                }

                .is-child {
                    cursor: pointer;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: flex-end;

                    background-size: cover;
                    position: relative;
                    transition: all 1s;

                    > h1 {
                        color: white;
                        font-size: 2em;
                        padding: 15px;
                        z-index: 3;
                        align-self: flex-start;
                    }

                    > h1:before {
                        content: ' ';
                        width: 1.5em;
                        display: block;
                        margin: 0;
                        border-bottom: 3px solid #f0f0f0;
                    }

                    &:after {
                        content: '\A';
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        top: 0;
                        left: 0;
                        background: rgba(0, 0, 0, 1);
                        opacity: 0;
                        transition: all 0.5s;
                        -webkit-transition: all 0.5s;
                        -moz-transition: all 0.5s;
                        z-index: 1;
                    }
                    &:hover:after {
                        opacity: 0.5;
                    }

                    &.almacen {
                        background-image: url('./../../assets/img/category-almacen.jpg');
                    }

                    &.frutas {
                        background-image: url('./../../assets/img/category-frutas.jpg');
                    }

                    &.hortalizas {
                        background-image: url('./../../assets/img/category-vegetales.jpg');
                    }

                    &.granja {
                        background-image: url('./../../assets/img/category-granja.jpg');
                    }

                    &.mermeladas {
                        background-image: url('./../../assets/img/category-mermeladas.jpg');
                    }

                    &.all {
                        background-color: $primary;
                    }
                }
            }
        }
    }
</style>